import { Container, ImageOne, ImageResponsive } from "./styles";

import DesktopBanner from "../../../assets/images/sections/banner/desktop.webp";
import MobileBanner from "../../../assets/images/sections/banner/mobile.webp";

const Banner = () => {
  return (
    <Container>
      <ImageOne src={DesktopBanner} alt="banner" />
      <ImageResponsive src={MobileBanner} alt="banner" />
    </Container>
  );
};

export default Banner;
